import { isArray } from 'lodash';

import api from './api';

import { convertToSend } from './utils';

const getPermission = () => {
  return api.get('user/me');
};

const getColumnsPreferences = () => {
  return api.get('/preferences/fields');
};

const getColumnsList = () => {
  return api.get('/setting/fields');
};

const updateColumnsList = fields => {
  return api.put('/preferences/fields', {
    fields,
  });
};

const getDirections = (direction, params) => {
  return api.get(`dictionary/${direction}/direction`, {
    params: {
      ...params,
    },
  });
};

const getResponsible = () => {
  return api.get('dictionary/grid/responsible');
};

const getEventTypes = (direction, params) => {
  return api.get(`dictionary/${direction}/eventType`, {
    params: {
      ...params,
    },
  });
};

const getGames = (direction, params) => {
  return api.get(`dictionary/${direction}/game`, {
    params: {
      ...params,
    },
  });
};

const getPlatforms = (direction, params) => {
  return api.get(`dictionary/${direction}/platform`, {
    params: {
      ...params,
    },
  });
};
const getAppVersionByDirection = (direction, params) => {
  return api.get(`dictionary/${direction}/appVersion`, {
    params: {
      ...params,
    },
  });
};

const getFormDirections = () => {
  return api.get('dictionary/game_product/direction');
};

const getFormEvents = direction => {
  return api.get(`dictionary/${direction}/eventType`);
};

const getChannels = (direction, params) => {
  return api.get(`dictionary/${direction}/channel`, {
    params: {
      ...params,
    },
  });
};

const getClassTags = (direction, params) => {
  return api.get(`dictionary/${direction}/classTag`, {
    params: {
      ...params,
    },
  });
};

const getTechTags = (direction, params) => {
  return api.get(`dictionary/${direction}/techTag`, {
    params: {
      ...params,
    },
  });
};

const getTypeTags = (direction, params) => {
  return api.get(`dictionary/${direction}/typeTag`, {
    params: {
      ...params,
    },
  });
};

const getVersions = (direction, game, platform) => {
  return api.get(`dictionary/${direction}/appVersion`, {
    params: {
      game: isArray(game) ? game : [game],
      platform,
    },
  });
};

const getFormGames = (direction, eventType, operation) => {
  return api.get(`dictionary/${direction}/game`, {
    params: {
      direction: isArray(direction) ? direction : [direction],
      eventType: isArray(eventType) ? eventType : [eventType],
      operation,
    },
  });
};

const getFormPlatforms = (direction, eventType, game) => {
  return api.get(`dictionary/${direction}/platform`, {
    params: {
      game: isArray(game) ? game : [game],
      direction: isArray(direction) ? direction : [direction],
      eventType: isArray(eventType) ? eventType : [eventType],
    },
  });
};

const getFormResponsible = (direction, game) => {
  return api.get(`dictionary/${direction}/responsible`, {
    params: {
      game: isArray(game) ? game : [game],
    },
  });
};

const getEvents = ({ sort, ...query }) => {
  const { field, order } = sort;
  const sortQuery = {};
  if (field && order) {
    sortQuery[`order[${field}]`] = order;
  }
  return api.get('events', {
    params: {
      ...query,
      ...sortQuery,
    },
  });
};

const getEvent = id => {
  return api.get(`events/${id}`);
};

const createEvent = event => {
  return api.post('events', convertToSend(event));
};

const updateEvent = ({ id, ...event }) => {
  return api.put(`events/${id}`, convertToSend(event));
};

const getExtraFieldsList = () => {
  return api.get('setting/filter/optional-fields');
};

export default {
  getPermission,
  getDirections,
  getEventTypes,
  getGames,
  getResponsible,
  getPlatforms,
  getEvents,
  getEvent,
  getVersions,
  getClassTags,
  getTechTags,
  getTypeTags,
  createEvent,
  updateEvent,
  getFormDirections,
  getFormEvents,
  getFormGames,
  getFormPlatforms,
  getFormResponsible,
  getColumnsPreferences,
  getColumnsList,
  getChannels,
  updateColumnsList,
  getExtraFieldsList,
  getAppVersionByDirection,
};
